import { fromJS } from 'immutable';
import identity from 'lodash/identity';
import { createSelector } from 'reselect';

import { status } from '@src/global/status';
import * as utils from '@src/utils/duckHelpers';

export const types = {
    ...utils.requestTypes('IMPACTING_POLICY'),
    IMPACTING_POLICY_MARK_AS_READ: 'IMPACTING_POLICY_MARK_AS_READ',
    IMPACTING_POLICY_MARK_AS_READ_SUCCESS: 'IMPACTING_POLICY_MARK_AS_READ_SUCCESS',
    IMPACTING_POLICY_MARK_AS_READ_FAILURE: 'IMPACTING_POLICY_MARK_AS_READ_FAILURE',
};

export const actions = {
    impacting_policySet: (obj) => utils.action(types.IMPACTING_POLICY_SET, obj),
    updateMarkAsRead: (id) => utils.action(types.IMPACTING_POLICY_MARK_AS_READ, { payload: { id } }),
    updateMarkAsReadSuccess: (response) => utils.action(types.IMPACTING_POLICY_MARK_AS_READ_SUCCESS, { payload: response }),
    updateMarkAsReadFailure: (error) => utils.action(types.IMPACTING_POLICY_MARK_AS_READ_FAILURE, { error }),
};

const initialState = fromJS({
    loaded: status.LOADING,
    impacting_policy: {},
    error: null,
});

export default (state = initialState, action) => {
    switch (action.type) {
    case types.IMPACTING_POLICY_GET:
        return state.merge({
            loaded: status.LOADING,
            error: null,
        });
    case types.IMPACTING_POLICY_SET:
        return state.merge({
            loaded: status.COMPLETE,
            impacting_policy: action.payload.impacting_policy,
            error: null,
        });
    case types.IMPACTING_POLICY_FAILURE:
        return state.merge({
            loaded: status.FAILED,
            impacting_policy: {},
            error: action.error,
        });
    case types.IMPACTING_POLICY_MARK_AS_READ:
        return state.merge({
            impacting_policy: action.payload.impacting_policy,
        });
    case types.IMPACTING_POLICY_MARK_AS_READ_SUCCESS:
        return state.merge({
            impacting_policy: action.payload.data.impacting_policy,
        });
    case types.IMPACTING_POLICY_RESET:
        return initialState;
    default:
        return state;
    }
};

const getImpactingPolicy = (state) => state.getIn(['app', 'impactingPolicy']);

export const selectors = {
    getImpactingPolicy: createSelector(identity, getImpactingPolicy),
};
